// extracted by mini-css-extract-plugin
export default {"mCard":"xG-z","image":"yG-z","imageNoBackground":"zG-z","fullWidth":"AG-z"};